import 'lazysizes'
// require('prismjs/themes/prism-okaidia.css')
require('prismjs/themes/prism-funky.css')
